import { render, staticRenderFns } from "./ModelProfile.vue?vue&type=template&id=6e648c67&scoped=true"
import script from "./ModelProfile.vue?vue&type=script&lang=js"
export * from "./ModelProfile.vue?vue&type=script&lang=js"
import style0 from "./ModelProfile.vue?vue&type=style&index=0&id=6e648c67&prod&lang=scss"
import style1 from "./ModelProfile.vue?vue&type=style&index=1&id=6e648c67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e648c67",
  null
  
)

export default component.exports